module.exports = __webpack_public_path__ + "img/symbol_1.3bf5b602.png";